export const mcpConsentEnUS = {
  documentTitle: "Approve a Connection · Invup",
  loginMessage: "Log in to approve a connection",
  framed: "Open this page directly to approve the connection.",
  title: "Approve a Connection",
  lede: "An app is asking to use your Invup account.",
  clientUnverified: "The app chose this name. Invup doesn't verify it.",
  returnTo: "After you choose, you'll return to:",
  returnToLoopback:
    "After you choose, you'll return to an app on this computer:",
  returnCaution: "Only continue if you started this connection yourself.",
  returnUnknown:
    "Invup can't confirm where this app will send you. Only continue if you trust it.",
  signedInAs: "Signed in as {{email}}.",
  switchAccount: "Switch Account",
  orgLegend: "Organization",
  orgHelper: "The connection works only in the organization you choose.",
  orgRole: "Your role: {{role}}",
  orgReason: {
    organization_opted_out:
      "Turned off by this organization. Someone who manages integrations can turn it on.",
    feature_required:
      "Needs the Pro plan. Ask your organization owner about upgrading.",
    unknown: "This organization can't connect right now.",
  },
  orgRequired: "Choose an organization to connect.",
  orgNoLongerEligible: "{{organization}} can no longer connect.",
  orgRefused: "You can no longer connect {{organization}}.",
  canTitle: "What This Connection Can Do",
  canIntro: "It acts as you, with your {{role}} role in {{organization}}.",
  canIntroNoRole: "It acts as you in {{organization}}.",
  canPlaceholder:
    "Choose an organization to see what this connection can do there.",
  capability: {
    time_logging: {
      self: "Log your own time entries",
    },
    time_entries: {
      all: "Read time entries for everyone in the organization",
      self: "Read your own time entries",
    },
    time_entry_editing: {
      all: "Edit time entries for everyone in the organization, including invoiced entries and locked dates",
      self: "Edit your own time entries, including invoiced ones, except on locked dates",
    },
    time_entry_deletion: {
      all: "Delete time entries for everyone in the organization, including invoiced entries and locked dates",
      self: "Delete your own time entries, including invoiced ones, except on locked dates",
    },
    reports: {
      all: "Read time summaries for the whole organization",
      self: "Read summaries of your own time",
    },
    projects: {
      all: "Read projects",
      self: "Read the projects you're assigned to",
    },
    clients: {
      all: "Read clients",
      self: "Read the clients of projects you're assigned to",
    },
    services: {
      all: "Read services",
    },
  },
  canRoleLimit:
    "Anything your role can't see or change in Invup, this connection can't either.",
  neverTitle: "What It Can Never Do",
  never: {
    profile: "Change your profile, password or sign-in settings",
    roles: "Change anyone's role or permissions",
    records: "Create, edit or delete projects, clients, services or invoices",
    money: "See rates, prices or amounts",
    otherOrgs: "Reach any organization other than the one you choose",
  },
  expiryTitle: "How Long It Lasts",
  expiryBody:
    "It stops working after 30 days without use. After 180 days, you'll need to approve it again. You can disconnect it at any time from your profile.",
  deny: "Deny",
  denying: "Denying…",
  approve: "Approve",
  approving: "Approving…",
  loadError:
    "Sorry, this connection request could not be loaded due to an error on our end. Please try again.",
  tryAgain: "Try Again",
  approveError:
    "Sorry, the connection could not be approved due to an error on our end. Please try again.",
  denyError:
    "Sorry, the request could not be denied due to an error on our end. Please try again.",
  approvedTitle: "Connection approved successfully",
  approvedBody:
    "{{client}} can now work in {{organization}} as you. Return to {{host}} to finish connecting.",
  approvedBodyUnknown:
    "{{client}} can now work in {{organization}} as you. Return to the app to finish connecting.",
  approvedResting:
    "Connection approved. Return to {{host}} to finish connecting.",
  approvedRestingUnknown:
    "Connection approved. Return to the app to finish connecting.",
  returnButton: "Return to {{host}}",
  returnButtonUnknown: "Return to the App",
  returnBlocked:
    "Invup couldn't send you back to this app. Start the connection again from the app.",
  deniedTitle: "Connection denied",
  deniedBody:
    "Nothing was shared with {{client}}, and no connection was created.",
  deniedHelper: "{{client}} will show that you denied the request.",
  goToDashboard: "Go to Dashboard",
  expiredTitle: "This Request Has Expired",
  expiredBody:
    "This connection request is no longer available. Requests expire after 10 minutes and can be used only once. Start the connection again from the app you were connecting.",
  unavailableTitle: "Connections Unavailable",
  unavailableBody:
    "Connections are temporarily unavailable, so nothing was shared. Your existing connections are kept. Try connecting again later.",
  noneTitle: "None of your organizations can connect yet",
  noneOrganization: "{{organization}}: {{reason}}",
  noneAvailable:
    "None of your organizations can be connected from this account.",
  noneDenyHint: "Deny the request so {{client}} stops waiting.",
};
